/**
 * DOMPurify is a DOM-only, super-fast, uber-tolerant XSS sanitizer for HTML, MathML and SVG.
 * https://github.com/cure53/DOMPurify
 */
import DOMPurify from 'dompurify'

export function useDomPurify() {
  function sanitize(dirty: any) {
    return DOMPurify.sanitize(dirty)
  }

  function replaceLineBreak(str: string | null) {
    if (str) {
      str = str.toString().replace(/\r\n|\r|\n/g, '<br />')
      return sanitize(str)
    }
    return ''
  }

  return {
    replaceLineBreak
    // sanitize
  }
}
